import React from 'react';
import {Col} from "react-materialize";
import AuthFromVK from "./AuthFromVK";

class MainFooter extends React.Component {

    render() {
        return (
            <footer className="page-footer purple darken-4">
                <div className="container">
                    <div className="row">
                        <div className="col l12 s12">
                            <span className="card-title">Маленькое описание. Тыц</span>
                            <span>
                            <h5>Как шифровать:</h5>
                            <ol>
                                <li>В поле <b><i>"текст"</i></b> пишете свой текст, в поле <b><i>"ключ"</i></b> вводите придуманный вами ключ. Но лучше всего нажать кнопку
                                    <b><i>"Генерировать ключ"</i></b>, так будет надёжней. <b>Ключ необходимо запомнить и передать по безопасному каналу человеку, с которым вы будете шифроваться для того,
                                что бы он тоже мог расшифровать и зашифровать информацию от вас и для вас!</b></li>
                                <li>Нажать кнопку <b><i>"Зашифровать"</i></b>, в появившемся окне <b><i>"Зашифрованный текст"</i></b></li> скопировать ваш шифр и передать кому нужно.
                            </ol>
                            <h5>Как расшифровать:</h5>
                            <ol>
                                <li>В поле <b><i>"Текст"</i></b> вставить полученный шифр от вашего собеседника.</li>
                                <li>В поле <b><i>"Ключ"</i></b> вставть ключ, который у вас должен быть для этой переписки <b>(Ни в коем случае нельзя генерировать новый, ибо вы тогда не сможете расшифровать текст вашего собеседника!).</b></li>
                                <li>Тыкнуть <b><i>"Расшифровать"</i></b></li>
                                <li>?????</li>
                                <li>Profit!</li>
                            </ol>
                            <h5>Немного о сложном ключе и сложных методах шифрования/дешифровки</h5>
                            <p>
                                Сложный ключ отличается от обычного тем, что для его вычисления происходит чуть больше расчётов, и нужен в основном только для того, что бы
                                зашифровать какие-то очень важные для вас данные. Он массивней, больше, и его труднее передать. Но он обеспечивает лучшую защиту вашей информации.
                                Рекомендуется его использовать в связке со <i>сложными</i> методами шифрования.
                            </p>
                            <p>
                                Принцип работы со <i>сложными</i> методами такой же, как и с обычными, только "тыкать" нужно на те кнопки, где есть надпись
                                <b><i>"Сложный"</i></b>. Ничего сложного <i>(Каламбурчик, ага)</i>.
                            </p>
                            <p>
                                Сложные методы шифрования отличаются от обычных только тем, что они чуть больше считаются, делается чуть больше "кругов" расчёта и так далее,
                                обеспечивая сложнее защиту данных. <b>Используйте что бы зашифровать МАКСИМАЛЬНО секретную информацию!</b>
                            </p>
                            <h5>Нахера всё вот это вот?</h5>
                            <p><i>Да так, прост)))0))00</i></p>
                            <h5>Окей, а какие методы используются?</h5>
                            <p>
                                неважно! <i>(DES в связке с AES, в сложных этот цикл повторяется n-ное кол-во раз)</i>
                            </p>
                            <h5>А не собирает ли этот сайт мои расшифрованные сообщения  и ключи!!??</h5>
                            <p>
                                <b>Нет, не собирает!</b>
                            </p>
                            <p>
                                <i>Я писал его в личных целях потому, что я не был уверен в сайтах с таким же функционалам в том, что они не собирают ключи/открытые сообщения и т.д.</i>,
                                поэтому можешь спокойно мне доверять, что <b>ни один байт твоей личной информации не утечёт за пределы этого сайта!</b>. Да что уж там говорть, <b>не утечёт за пределы этой сессии!</b>
                            </p>
                            <h5>Чё всё так уродски выглядит? Ну что это за жопа с дизайном?</h5>
                            <p>
                                Эта хуета была написана за пару часов глубокого утра и бессонной ночи. Я кста иконку спиздил, гыг. <b>Пойду курну что ли...</b>
                            </p>
                        </span>
                        </div>
                    </div>
                </div>
                <div className="footer-copyright">
                    <div className="container">
                        © 2019-∞ Ivan Grib
                        <a className="grey-text text-lighten-4 right" href="https://vk.com/spbg_grib" target='_blank'>VK</a>
                    </div>
                </div>
            </footer>
        )
    }
}

export default MainFooter;